module.exports = __webpack_public_path__ + "static/media/electrical.45727bba.png";